import { useRoof } from '../../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../../material/cachedMeshPhysicalMaterial'

interface Props {
  position: [number, number, number]
  rotation: [number, number, number]
  size: [number, number, number]
}

export const SideTie = ({ position, rotation, size }: Props): JSX.Element => {
  const { color } = useRoof()

  return (
    <mesh
      castShadow={true}
      position={position}
      rotation={rotation}
      receiveShadow={true}
    >
      <boxGeometry args={size} />
      <CachedMeshPhysicalMaterial color={color} />
    </mesh>
  )
}
